// Vendor
import { createReducer, on } from '@ngrx/store';
// Actions
import { setAdvancedOptions } from './advanced-options.actions';
import { setCustomPDFReportBuilderStore } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/custom-pdf-report-builder/custom-pdf-report-builder.action';
export const advanced_options = createReducer(null, on(setCustomPDFReportBuilderStore, setAdvancedOptions, (state, action) => {
    return action.advanced_options;
}));
